// extracted by mini-css-extract-plugin
export var title = "Highlights-module--title--3dxZ1";